import { isPowerKind, powerCablesCompatible } from '../types/deviceModel';
import { parsePortEndpointId } from './portNamingSchemes';

export function powerCableGuard(from: string, to: string): 'ok' | 'reject' | 'force-power' {
  const ka = parsePortEndpointId(from)?.kind;
  const kb = parsePortEndpointId(to)?.kind;
  const pa = isPowerKind(ka);
  const pb = isPowerKind(kb);
  if (!pa && !pb) return 'ok';
  if (pa && pb && powerCablesCompatible(ka, kb)) return 'force-power';
  return 'reject';
}
